import { render, staticRenderFns } from "./createModal.vue?vue&type=template&id=b544cccc&scoped=true&"
import script from "./createModal.vue?vue&type=script&lang=js&"
export * from "./createModal.vue?vue&type=script&lang=js&"
import style0 from "./createModal.vue?vue&type=style&index=0&id=b544cccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544cccc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b544cccc')) {
      api.createRecord('b544cccc', component.options)
    } else {
      api.reload('b544cccc', component.options)
    }
    module.hot.accept("./createModal.vue?vue&type=template&id=b544cccc&scoped=true&", function () {
      api.rerender('b544cccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/promotions/components/createModal.vue"
export default component.exports